<template>
  <div class="payment-layout">
    <div class="payment-info">
      <div class="product">
        <div v-if="productInfo" class="image">
          <img
            v-if="productInfo.imagePath"
            onerror="this.style.display= 'none';"
            :src="productInfo.imagePath"
          />
        </div>
        <div class="detail">
          <div class="name">
            {{ productInfo.title }}
          </div>
          <div class="price">
            <span class="real-price" v-if="productInfo.paymentRestrict == 1">
              <span class="points">
                <img src="@/assets/img/icon/pi-point.svg" />
              </span>
              {{ productInfo.price }}
            </span>
            <span v-else class="real-price">${{ productInfo.price }}</span>
            <span class="ori-price">${{ productInfo.originalPrice }}</span>
          </div>
        </div>
      </div>
      <div class="order">
        <v-form id="buyerInfo" ref="formMain">
          <div class="input-title" v-if="!productInfo.isGroupCoupon">
            購買數量
          </div>
          <v-select
            v-if="!productInfo.isGroupCoupon"
            filled
            dense
            hide-details
            :items="qtyOpts"
            v-model="qty"
            height="46"
            class="mb-3"
          ></v-select>
          <div class="input-title" v-if="storeOpts.length > 1">分店</div>
          <v-select
            filled
            dense
            hide-details
            :items="storeOpts"
            v-model="storeGuid"
            height="46"
            class="mb-3"
            v-if="storeOpts.length > 1"
          ></v-select>
          <div class="input-title">手機號碼</div>
          <v-text-field
            v-if="!usePi"
            v-model="buyerInfo.mobile"
            :maxlength="10"
            :rules="[requiredRule, phoneRule]"
          />
          <div v-else class="pi-mobile mb-4">{{ buyerInfo.mobile }}</div>
        </v-form>
      </div>
      <div v-if="recipientMethod === '2'">
        <div class="payment-section pb-0">
          <div class="payment-title">收件人資訊</div>
          <v-form id="recipientInfo" ref="formInfo">
            <v-row>
              <v-col class="py-0" cols="12">
                <v-checkbox
                  v-model="sameWithBuyer"
                  class="mt-0 pt-2"
                  label="同購買人"
                  off-icon
                />
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  v-model="recipient.Name"
                  placeholder="姓名"
                  validate-on-blur
                  :rules="[requiredRule, specialRule]"
                />
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field
                  id="recipientMobile"
                  type="tel"
                  v-model="recipient.Mobile"
                  placeholder="手機號碼"
                  :rules="[requiredRule, phoneRule]"
                  :maxlength="10"
                  validate-on-blur
                />
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-form id="shipAddr" ref="formShipAdr">
              <v-col class="py-0" cols="12">
                <div class="payment-section__head">取貨方式</div>
                <v-radio-group v-model="recipientMethod">
                  <v-radio label="宅配到府" value="2" off-icon />
                </v-radio-group>
                <v-row>
                  <v-col class="py-0" cols="6">
                    <v-select
                      v-model="recipient.cityId"
                      class="v-select--no-label"
                      :items="cityItems"
                      item-text="name"
                      item-value="index"
                      label="選擇縣市"
                      :rules="[requiredRuleAddr]"
                      validate-on-blur
                    />
                  </v-col>
                  <v-col class="py-0" cols="6">
                    <v-select
                      v-model="recipient.townId"
                      class="v-select--no-label"
                      :items="townItems"
                      item-text="name"
                      item-value="index"
                      label="行政區"
                      no-data-text="請先選擇縣市"
                      :rules="[requiredRuleAddr]"
                      validate-on-blur
                    />
                  </v-col>
                </v-row>
                <v-text-field
                  v-model="recipient.address"
                  class="v-text-field--no-label"
                  single-line
                  :error-messages="shipAddrErr"
                  placeholder="街道地址"
                  :rules="[requiredRule]"
                  @blur="validateAddr('ship')"
                  validate-on-blur
                />
              </v-col>
            </v-form>
          </v-row>
        </div>
      </div>
      <!--
        發票開立資訊
      -->
      <div class="payment-section receipt">
        <div id="receiptInput" class="payment-title">發票資訊</div>
        <v-radio-group
          v-model="receipt.receiptType"
          class="ma-0 no-message"
          @change="sameWithDelivery = false"
        >
          <v-radio class="ma-0 py-2" label="捐贈" value="5" off-icon />
          <v-form ref="form5">
            <div v-if="receipt.receiptType === '5'">
              <v-radio-group
                :disabled="loveCodeErr == '驗證中'"
                @change="cleanSelfCode"
                v-model="receipt.loveCode"
                class="loveCodeGroup ma-0"
              >
                <v-radio
                  class="ma-0 pt-1 pb-2"
                  label="創世社會福利基金會"
                  :value="'919'"
                  off-icon
                />
                <v-radio
                  class="ma-0 py-2"
                  label="陽光社會福利基金會"
                  :value="'13579'"
                  off-icon
                />
                <v-radio
                  class="ma-0 py-2"
                  label="自行輸入"
                  :value="'selfCode'"
                  off-icon
                />
                <div class="otherLovecode">
                  <v-text-field
                    id="loveCode"
                    type="tel"
                    v-model="selfCode"
                    :error-messages="loveCodeErr"
                    placeholder="請輸入愛心碼 (3-7碼數字)"
                    :maxlength="7"
                    @focus="
                      () => {
                        receipt.loveCode = 'selfCode'
                      }
                    "
                    @blur="validateLoveCode"
                  />
                  <a
                    class="lovecode-link"
                    href="https://www.einvoice.nat.gov.tw/APCONSUMER/BTC603W/"
                  >
                    查詢社福團體愛心碼
                  </a>
                </div>
              </v-radio-group>
            </div>
          </v-form>
          <!-- <v-radio class="ma-0 py-2" label="手機條碼載具" value="2" off-icon />
          <v-form ref="form2">
            <div v-if="receipt.receiptType === '2'">
              <div class="input-title">手機條碼載具</div>
              <v-text-field
                id="mobileId"
                v-model="receipt.phoneCarrier"
                :rules="[phoneCarrierRule]"
                validate-on-blur
                :error-messages="phoneCarrierErr"
                @blur="validateCarrier"
              />
            </div>
          </v-form> -->
          <v-radio class="ma-0 py-2" label="康太平台載具" value="1" off-icon />
          <v-form v-if="receipt.receiptType === '1'" ref="form1">
            <div class="input-title">發票收件人姓名</div>
            <v-text-field
              validate-on-blur
              v-model="buyerInfo.name"
              :rules="[requiredRule, specialRule]"
            />
            <div class="receipt-note">
              地址 (中獎後發票會寄送此地址)
            </div>
            <v-checkbox
              v-if="recipientMethod === '2'"
              v-model="sameWithDelivery"
              class="mt-0 pt-2"
              label="同宅配地址"
              off-icon
            />
            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                  v-model="receipt.cityId"
                  class="v-select--no-label"
                  :items="cityItems"
                  item-text="name"
                  item-value="index"
                  label="選擇縣市"
                  :rules="[requiredRuleAddr]"
                  validate-on-blur
                />
              </v-col>
              <v-col class="py-0" cols="6">
                <v-select
                  v-model="receipt.townId"
                  class="v-select--no-label"
                  :items="townItems_receipt"
                  item-text="name"
                  item-value="index"
                  label="行政區"
                  no-data-text="請先選擇縣市"
                  :rules="[requiredRuleAddr]"
                  validate-on-blur
                />
              </v-col>
            </v-row>
            <v-text-field
              v-model="receipt.address"
              class="v-text-field--no-label"
              single-line
              :error-messages="receiptAddrErr"
              placeholder="街道地址"
              :rules="[requiredRule]"
              @blur="validateAddr('receipt')"
              validate-on-blur
            />
          </v-form>
          <!-- <v-radio
            class="ma-0 py-2"
            label="自然人憑證條碼載具"
            value="3"
            off-icon
          />
          <v-form ref="form3">
            <div v-if="receipt.receiptType === '3'">
              <div class="input-title">自然人憑證條碼載具</div>
              <v-text-field
                id="personalId"
                v-model="receipt.personalCertificateCarrier"
                :rules="[personalCertificateCarrierRule]"
                validate-on-blur
              />
            </div>
          </v-form> -->
          <v-radio
            class="ma-0 py-2"
            label="三聯式紙本發票"
            value="4"
            off-icon
          />
          <v-form v-if="receipt.receiptType === '4'" ref="form4">
            <div>
              <div class="input-title">發票抬頭</div>
              <v-text-field
                id="pepperReceipt"
                v-model="receipt.receiptTitle"
                :rules="[requiredRule, specialRule]"
                validate-on-blur
              />
              <div class="input-title">統一編號</div>
              <v-text-field
                v-model="receipt.taxIdNumber"
                :rules="[requiredRule, specialRule, taxIdRule]"
                validate-on-blur
              />
              <div class="input-title">發票收件人姓名</div>
              <v-text-field
                v-model="receipt.receiverName"
                :rules="[requiredRule, specialRule]"
                validate-on-blur
              />
            </div>
            <v-checkbox
              v-if="recipientMethod === '2'"
              v-model="sameWithDelivery"
              class="mt-0 pt-2"
              label="同宅配地址"
              off-icon
            />
            <div class="receipt-note">
              發票(中獎後發票會寄送此地址)
            </div>
            <v-row>
              <v-col class="py-0" cols="6">
                <v-select
                  v-model="receipt.cityId"
                  class="v-select--no-label"
                  :items="cityItems"
                  item-text="name"
                  item-value="index"
                  label="選擇縣市"
                  :rules="[requiredRuleAddr]"
                  validate-on-blur
                />
              </v-col>
              <v-col class="py-0" cols="6">
                <v-select
                  v-model="receipt.townId"
                  class="v-select--no-label"
                  :items="townItems_receipt"
                  item-text="name"
                  item-value="index"
                  label="行政區"
                  no-data-text="請先選擇縣市"
                  :rules="[requiredRuleAddr]"
                  validate-on-blur
                />
              </v-col>
            </v-row>
            <v-text-field
              v-model="receipt.address"
              class="v-text-field--no-label"
              single-line
              :error-messages="receiptAddrErr"
              placeholder="街道地址"
              :rules="[requiredRule]"
              @blur="validateAddr('receipt')"
              validate-on-blur
            />
            <div class="receipt-note py-2">
              依統一發票使用辦法規定，個人發票一經開立，不得更改或改開公司戶發票。
            </div>
          </v-form>
        </v-radio-group>
      </div>
      <div class="payment-section" style="padding-bottom: 146px;">
        <div id="coupon">
          <div class="payment-title">折扣碼</div>
          <v-text-field
            v-model="couponCode"
            :success-messages="couponSuccessMsg"
            :error-messages="couponErrorMsg"
            @blur="checkCoupon"
            @change="couponCodeChecked = false"
          />
        </div>
        <div class="payment-title">
          訂單通知
          <span>(選填)</span>
        </div>
        <v-text-field
          v-model="buyerInfo.email"
          :rules="[emailRule]"
          validate-on-blur
          placeholder="輸入 E-mail 以接收交易結果"
        ></v-text-field>

        <div class="check-col mb-3">
          <v-checkbox
            v-model="saveReceipt"
            class="agreement-check"
            label="記住發票設定"
            off-icon
          />
        </div>
        <div class="d-flex align-center pb-4 check-col mb-3">
          <v-checkbox
            v-model="agreement"
            class="agreement-check agreement-cus"
            off-icon
            on-icon="check_box"
          />
          我同意拍享券服務
          <span @click="toLink('GuideLine')" class="underline-link">
            使用規範
          </span>
          與
          <span @click="toLink('Privacy')" class="underline-link">
            隱私權條款
          </span>
        </div>
      </div>
      <div class="order block-btm">
        <div class="info-col">
          <div class="name">折扣</div>
          <div class="value">- {{ discount }}</div>
        </div>
        <div class="info-col">
          <div class="name">結帳金額</div>
          <div class="value">$ {{ sum }}</div>
        </div>
        <v-btn
          color="primary"
          :disabled="!isNextStepOn"
          :outlined="!isNextStepOn"
          block
          depressed
          @click="pay"
          class="mt-4"
        >
          {{ isPimode ? '結帳' : '付款方式' }}
        </v-btn>
      </div>
    </div>
    <waiting-overlay v-model="submitting"></waiting-overlay>
  </div>
</template>

<script>
import WaitingOverlay from '@/components/shared/WaitingOverlay'
export default {
  name: 'PaymentInfoInfo',
  components: {
    WaitingOverlay,
  },
  data: function() {
    return {
      usePi: false,
      isPimode: true,
      productInfo: {
        deliveryType: '1',
        isGroupCoupon: false,
        imagePath: '',
        originalPrice: 0,
        price: 0,
        spec: '',
        title: '',
      },
      buyerInfo: {
        name: '',
        mobile: '',
        email: '',
      },
      recipientMethod: '2',
      recipient: {
        Name: '',
        Mobile: '',
        cityId: null,
        townId: null,
        address: '',
        zipCode: '',
      },
      shipAddrErr: '',
      receiptAddrErr: '',
      loveCodeErr: '',
      phoneCarrierErr: '',
      receipt: {
        receiptType: '5',
        cityId: null,
        townId: null,
        address: '',
        zipCode: '',

        receiptTitle: '',
        taxIdNumber: '',
        receiverName: '',

        phoneCarrier: '',
        personalCertificateCarrier: '',
        loveCode: '919',
      },
      selfCode: '',
      saveReceipt: true,
      sameWithBuyer: false,
      sameWithDelivery: false,

      agreement: true,
      isNextStepOn: true,

      cityTownships: [],
      id: '',
      variation: '', // 商品規格
      qty: 0,
      storeGuid: '',
      couponCode: '',
      couponCodeChecked: false,
      couponSuccessMsg: '',
      couponErrorMsg: '',
      discount: 0,
      submitting: false,
      qtyOpts: [],
      qtyMaxinum: '',
      qtyMinimum: '',
      storeOpts: [],
    }
  },
  computed: {
    cityItems() {
      const list = []
      this.cityTownships.forEach((city, index) => {
        list.push({ id: city.id, name: city.name, index })
      })
      return list
    },
    townItems() {
      const selectCity = this.cityTownships[this.recipient.cityId]
      if (selectCity) {
        selectCity.townshipsList.map((town, index) => {
          town.index = index
        })
        return selectCity.townshipsList
      } else {
        return []
      }
    },
    townItems_receipt() {
      const selectCity = this.cityTownships[this.receipt.cityId]
      if (selectCity) {
        selectCity.townshipsList.map((town, index) => {
          town.index = index
        })
        return selectCity.townshipsList
      } else {
        return []
      }
    },
    sum() {
      if (this.productInfo.isGroupCoupon) {
        return this.productInfo.price + this.discount || 0
      } else {
        return this.qty * this.productInfo.price + this.discount || 0
      }
    },
    useMock() {
      return process.env.VUE_APP_USE_DEV == 'true'
    },
  },
  watch: {
    sameWithBuyer: function(newVal) {
      if (newVal && this.recipientMethod === '2') {
        this.recipient.Name = this.buyerInfo.name
        this.recipient.Mobile = this.buyerInfo.mobile
        this.$refs.formInfo.resetValidation()
      } else {
        this.recipient.Name = ''
        this.recipient.Mobile = ''
      }
    },
    sameWithDelivery: function(val) {
      if (val) {
        this.receipt.cityId = this.recipient.cityId
        this.receipt.townId = this.recipient.townId
        this.receipt.address = this.recipient.address
        this.$refs.form1.resetValidation()
        this.validateAddr()
      } else {
        this.receipt.cityId = null
        this.receipt.townId = null
        this.receipt.address = null
      }
    },
    agreement: function(newVal) {
      if (this.agreement) {
        this.isNextStepOn = true
      } else {
        this.isNextStepOn = false
      }
    },
  },
  mounted: async function() {
    let piInfo
    if (
      !!localStorage.getItem('PI_UID') &&
      localStorage.getItem('PI_UID') !== 'test'
    ) {
      const res = await api.getPiUserInfo(
        JSON.parse(localStorage.getItem('PI_TOKEN')).access_token,
        localStorage.getItem('PI_UID')
      )
      piInfo = res.data
      if (piInfo != null) {
        this.usePi = true
        this.buyerInfo.mobile = piInfo.mobile_phone || ''
        this.buyerInfo.email = piInfo.email || ''
        this.receipt.phoneCarrier = piInfo.invoice_carrier || ''
      }
    }
    await this.getCityList()
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.checkProduct()
      if (this.$route.params.deliveryType)
        this.recipientMethod = this.$route.params.deliveryType.toString()
      this.variation = this.$route.params.variation
      this.qty = this.$route.params.qty
      this.qtyMaxinum = this.$route.params.qtyMaxinum
      this.qtyMinimum = this.$route.params.qtyMinimum
      this.storeOpts = this.$route.params.storeOpts
      this.storeGuid = this.storeOpts[0].value
      this.productInfo = this.$route.params.productInfo
      this.getQtyOpts()
      this.getStoreOpts()

      const checkoutRs = await api.getCheckoutInfo()

      if (checkoutRs.code === 1000) {
        const einvoiceInfo = checkoutRs.data.einvoice
        switch (einvoiceInfo.carrierType) {
          case 0:
            if (einvoiceInfo.invoiceType == 2) {
              // 捐贈
              this.receipt.receiptType = '5'
              if (
                einvoiceInfo.loveCode == '13579' ||
                einvoiceInfo.loveCode == '919'
              ) {
                this.receipt.loveCode = einvoiceInfo.loveCode
              } else {
                this.receipt.loveCode = 'selfCode'
                this.selfCode = einvoiceInfo.loveCode
              }
            } else {
              // 三聯
              this.receipt.receiptType = '4'
              this.receipt.receiptTitle = einvoiceInfo.invoiceComName
              this.receipt.taxIdNumber = einvoiceInfo.invoiceComId
              this.receipt.receiverName =
                einvoiceInfo.name || einvoiceInfo.invoiceBuyerName
            }
            break
          case 1: // 會員載具
            this.receipt.receiptType = '1'
            break
          case 2: // 手機條碼
            this.receipt.receiptType = '5'
            // this.receipt.receiptType = '2'
            // this.receipt.phoneCarrier =
            //   this.usePi && piInfo.invoice_carrier
            //     ? piInfo.invoice_carrier
            //     : einvoiceInfo.carrierId
            break
          case 3: // 自然人憑證
            this.receipt.receiptType = '5'
            // this.receipt.receiptType = '3'
            // this.receipt.personalCertificateCarrier = einvoiceInfo.carrierId
            break
        }
        this.setRceiptAddrFromInitial(
          einvoiceInfo.address || einvoiceInfo.invoiceAddress
        )

        const buyerInfo = checkoutRs.data.buyer
        this.buyerInfo.name = buyerInfo.name
        this.buyerInfo.email =
          this.usePi && piInfo.email ? piInfo.email : buyerInfo.email
        this.buyerInfo.mobile =
          this.usePi && piInfo.mobile_phone
            ? piInfo.mobile_phone
            : buyerInfo.mobile
      }
    } else {
      const cartJson = localStorage.getItem('shoppingCart')
      if (cartJson != null) {
        const cart = JSON.parse(cartJson)
        this.id = cart.id
        this.checkProduct()
        if (cart.expired > new Date().getTime()) {
          this.variation = cart.variation
          this.qty = cart.qty
          this.storeGuid = cart.storeGuid
          this.recipientMethod = cart.deliveryType
          this.productInfo = cart.productInfo
          if (cart.paymentInfo != null) {
            // 表單回填
            const BuyerInfo = cart.paymentInfo.BuyerInfo
            const ShippingInfo = cart.paymentInfo._shippingInfo
            const receiptInfo = cart.paymentInfo._receiptInfo
            if (BuyerInfo != null) this.buyerInfo = BuyerInfo
            if (ShippingInfo != null) {
              this.recipient = ShippingInfo
              if (
                this.recipientMethod === '2' &&
                this.recipient.Name === ShippingInfo.Name &&
                this.recipient.Mobile === ShippingInfo.Mobile &&
                cart.paymentInfo.sameWithBuyer
              ) {
                this.sameWithBuyer = true
              }
              setTimeout(() => {
                this.validateAddr('ship')
              }, 1200)
            }
            if (receiptInfo != null) {
              this.receipt = receiptInfo
              if (
                this.recipientMethod === '2' &&
                this.receipt.cityId === receiptInfo.cityId &&
                this.receipt.townId === receiptInfo.townId &&
                this.receipt.address === receiptInfo.address &&
                cart.paymentInfo.sameWithDelivery
              ) {
                this.sameWithDelivery = true
              }
              if (
                receiptInfo.receiptType === '1' ||
                receiptInfo.receiptType === '4'
              ) {
                setTimeout(() => {
                  this.validateAddr()
                }, 1200)
              }
            }
          }
        } else {
          localStorage.removeItem('shoppingCart')
          this.$bus.$emit('callAllert', {
            messageContent: '閒置過久，請重新購買！',
            callback: () => {
              this.$router.push({ name: 'product', params: { id: this.id } })
            },
          })
          return
        }
      } else {
        this.$bus.$emit('callAllert', {
          messageContent: '發生了一點錯誤！',
          callback: () => {
            if (localStorage.getItem('source') === 'e7g') {
              window.location = process.env.VUE_APP_E7G_HOME
            } else {
              this.$router.replace({ name: 'home' })
            }
          },
        })
        return
      }
    }
  },
  methods: {
    cleanSelfCode() {
      this.loveCodeErr = ''
      this.selfCode = ''
    },
    async getCityList() {
      try {
        const res = await api.getCityTownships()
        this.cityTownships = res.data
      } catch (error) {
        this.handleError('系統錯誤:' + error.code)
      }
    },
    async validateLoveCode() {
      const formatCheck = this.loveCodeRule(this.selfCode)
      console.log(formatCheck)
      if (formatCheck !== true) {
        this.loveCodeErr = formatCheck
        console.log('0000')
        return
      }
      if (this.loveCodeErr === '驗證中') return
      this.loveCodeErr = '驗證中'
      try {
        await api.validateEinvoiceInfo(1, this.selfCode)
        this.loveCodeErr = ''
      } catch (error) {
        this.loveCodeErr = error.message ? error.message : '查無愛心碼'
        console.log(error)
      }
    },
    async validateCarrier() {
      if (!this.receipt.phoneCarrier) {
        this.phoneCarrierErr = ''
        return
      }
      if (this.phoneCarrierErr === '驗證中') return
      this.phoneCarrierErr = '驗證中'
      try {
        await api.validateEinvoiceInfo(2, this.receipt.phoneCarrier)
        this.phoneCarrierErr = ''
      } catch (error) {
        this.phoneCarrierErr = error.message ? error.message : '驗證失敗'
        console.log(error)
      }
    },
    async validateAddr(string) {
      let addr = ''
      let zipCode = 0
      if (string === 'ship') {
        if (!this.recipient.address) {
          this.shipAddrErr = ''
          return
        }
        this.shipAddrErr = '驗證中'
        addr =
          this.cityItems[this.recipient.cityId].name +
          this.townItems[this.recipient.townId].name +
          this.recipient.address
        zipCode = this.townItems[this.recipient.townId].zipCode
      } else {
        if (!this.receipt.address) {
          this.receiptAddrErr = ''
          return
        }
        this.receiptAddrErr = '驗證中'
        addr =
          this.cityItems[this.receipt.cityId].name +
          this.townItems_receipt[this.receipt.townId].name +
          this.receipt.address
        zipCode = this.townItems_receipt[this.receipt.townId].zipCode
      }
      let result = ''
      await api
        .validateAddress(addr, zipCode)
        .then(function(res) {
          if (res.code != 1000) {
            result = '請再次確認地址'
          } else {
            result = ''
          }
        })
        .catch(function(err) {
          result = '請再次確認地址'
        })
      if (string === 'ship') {
        this.shipAddrErr = result
      } else {
        this.receiptAddrErr = result
      }
    },
    validCheckout: function() {
      let res1 = true
      let res2 = true
      let res3 = true
      let res4 = 0
      res1 = this.$refs.formMain.validate()
      if (this.recipientMethod === '2') {
        res2 = this.$refs.formInfo.validate()
        res3 = this.$refs.formShipAdr.validate() && this.shipAddrErr == ''
      }

      switch (this.receipt.receiptType) {
        case '1':
          res4 =
            this.$refs.form1.validate() && this.receiptAddrErr == '' ? 0 : 4 // 平台載具
          break
        case '2':
          res4 =
            this.$refs.form2.validate() && this.phoneCarrierErr == '' ? 0 : 5 // 手機條碼
          break
        case '3':
          res4 = this.$refs.form3.validate() ? 0 : 6 // 自然人憑證
          break
        case '4':
          res4 =
            this.$refs.form4.validate() && this.receiptAddrErr == '' ? 0 : 7 // 紙本發票
          break
        case '5':
          if (this.receipt.loveCode == 'selfCode') {
            if (this.selfCode == '') {
              this.loveCodeErr = '必填項目'
            }
            if (this.loveCodeErr !== '') {
              res4 = 8
            }
          }
          break
        default:
          res4 = 4
      }
      const result = !res1 ? 1 : !res2 ? 2 : !res3 ? 3 : res4
      return result
    },
    jumpToFillUp: function(errorFormCode) {
      switch (errorFormCode) {
        case 1:
          document.getElementById('buyerInfo').scrollIntoView()
          break
        case 2:
          document.getElementById('recipientInfo').scrollIntoView()
          break
        case 3:
          document.getElementById('shipAddr').scrollIntoView()
          break
        case 4:
          document.getElementById('receiptInput').scrollIntoView()
          break
        case 5:
          document.getElementById('mobileId').scrollIntoView()
          break
        case 6:
          document.getElementById('personalId').scrollIntoView()
          break
        case 7:
          document.getElementById('pepperReceipt').scrollIntoView()
          break
        case 8:
          document.getElementById('loveCode').scrollIntoView()
          break
      }
    },
    setRceiptAddrFromInitial(address) {
      if (address) {
        const splitAddr = address.split(' ')
        this.receipt.address = splitAddr[3]
        const cityIndex = this.cityTownships.findIndex(city => {
          return city.name == splitAddr[1]
        })
        const townIndex = this.cityTownships[cityIndex].townshipsList.findIndex(
          town => {
            return town.name === splitAddr[2]
          }
        )
        this.receipt.cityId = cityIndex
        this.receipt.townId = townIndex
      }
    },
    getShippingInfo() {
      if (this.recipient.cityId != null && this.recipient.townId != null) {
        const ShippingInfo = JSON.parse(JSON.stringify(this.recipient))
        const city = this.cityItems[this.recipient.cityId]
        const town = this.townItems[this.recipient.townId]
        ShippingInfo.cityId = city.id
        ShippingInfo.townId = town.id
        ShippingInfo.zipCode = town.zipCode
        ShippingInfo.address = city.name + town.name + this.recipient.address
        return ShippingInfo
      } else {
        return {}
      }
    },
    getReceiptAddr() {
      const city = this.cityItems[this.receipt.cityId]
      const town = this.townItems_receipt[this.receipt.townId]
      return (
        town.zipCode +
        ' ' +
        city.name +
        ' ' +
        town.name +
        ' ' +
        this.receipt.address
      )
    },
    getEinvoiceInfo() {
      const result = {}
      if (this.receipt.receiptType == '1') {
        // 二聯式電子發票：平台載具
        result.invoiceType = 2
        result.carrierType = 1
        result.invoiceAddress = this.getReceiptAddr()
      } else if (this.receipt.receiptType == '2') {
        // 二聯式電子發票：手機條碼載具
        result.invoiceType = 2
        result.carrierType = 2
        result.carrierId = this.receipt.phoneCarrier
      } else if (this.receipt.receiptType == '3') {
        // 二聯式電子發票：自然人憑證條碼載具
        result.invoiceType = 2
        result.carrierType = 3
        result.carrierId = this.receipt.personalCertificateCarrier
      } else if (this.receipt.receiptType == '4') {
        // 三聯式紙本發票
        result.invoiceType = 1
        result.carrierType = 0
        result.invoiceComId = this.receipt.taxIdNumber
        result.invoiceComName = this.receipt.receiptTitle
        result.invoiceBuyerName = this.receipt.receiverName
        result.invoiceAddress = this.getReceiptAddr()
      } else if (this.receipt.receiptType == '5') {
        // 捐贈
        result.invoiceType = 2
        result.carrierType = 0
        result.loveCode =
          this.receipt.loveCode == 'selfCode'
            ? this.selfCode
            : this.receipt.loveCode
      }
      return result
    },
    pay: async function() {
      this.submitting = true
      if (this.couponCode != '' && !this.couponCodeChecked) {
        setTimeout(() => {
          this.pay()
        }, 700)
        return
      }
      if (this.couponErrorMsg != '') {
        document.getElementById('coupon').scrollIntoView()
        this.submitting = false
        return
      }
      const formCheck = await this.validCheckout()
      if (formCheck > 0) {
        this.jumpToFillUp(formCheck)
        this.submitting = false
        return
      }
      this.piPay()
    },
    handleError(msg) {
      this.$bus.$emit('callAllert', {
        messageContent: msg,
        callback: () => {
          window.history.go(-1)
        },
      })
    },
    checkProduct: function() {
      const self = this
      api
        .checkProduct(self.id)
        .then(res => {
          const checkedInfo = res.data
          if (checkedInfo.isSoldOut) {
            this.handleError('商品已售完')
          }
        })
        .catch(err => {
          console.log(err)
          if (err.message) this.handleError(err.message || '商品目前無法購買')
        })
    },
    loveCodeRule: function(value) {
      if (this.receipt.loveCode != 'selfCode') return true
      if (value == null || value == '') return '必填項目'
      const pattern = /[0-9]{3,7}/
      if (
        value.length < 3 ||
        value.length > 7 ||
        pattern.test(value) == false
      ) {
        return '3到7碼的愛心碼.'
      }
      return true
    },
    phoneCarrierRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /^\/[0-9A-Z\-.$/\+%\*\s]*$/
      if (value.length != 8 || pattern.test(value) == false) {
        return '請輸入正確格式'
      }
      return true
    },
    personalCertificateCarrierRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /^[A-Z][A-Z]\d{14}$/
      if (value.length != 16 || pattern.test(value) == false) {
        return '請輸入正確格式'
      }
      return true
    },
    requiredRule: function(value) {
      if (value == null || value == '') return '必填項目'
      return true
    },
    requiredRuleAddr(value) {
      if (value == null) return '必填項目'
      return true
    },
    emailRule: function(value) {
      if (value == null || value == '') return true
      const pattern = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
      if (!pattern.test(value)) {
        return '請輸入正確格式'
      }
      return true
    },
    phoneRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const pattern = /09[0-9]{8}/
      return pattern.test(value) || '請輸入正確格式'
    },
    specialRule: function(value) {
      if (value == null || value == '') return '必填項目'
      const spChar = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im
      const emoji = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi
      if (spChar.test(value) || emoji.test(value)) {
        return '請輸入正確格式'
      } else {
        return true
      }
    },
    taxIdRule: function(value) {
      if (value == null || value == '') return '必填項目'
      // 統編驗證
      // 長度要 8 位數
      const reg = /^\d{8}$/
      // 固定是錯誤的統編
      const invalid = '00000000, 11111111'
      // 這邊檢查到有錯就可以先提示使用者，不用進入計算了
      if (!reg.test(value) || invalid.indexOf(value) != -1) {
        return '請輸入正確格式'
      }
      // 公式
      const formula = [1, 2, 1, 2, 1, 2, 4, 1]
      // 檢查用函式
      const validOperator = digit => {
        const ones = digit % 10
        const tens = (digit - ones) / 10
        return ones + tens
      }
      // 運算
      const sum = formula
        .map((f, i) => {
          return validOperator(parseInt(value[i]) * f)
        })
        .reduce((acc, cur) => {
          return acc + cur
        })
      // 結果
      console.log('sum', sum, 'value[6]', value[6], 'sum+1%10', (sum + 1) % 10)
      if (sum % 10 == 0 || (value[6] == '7' && (sum + 1) % 10 == 0)) {
        return true
      } else {
        return '請輸入正確格式'
      }
    },
    toLink(name) {
      this.saveInfo()
      this.$router.push({ name: name })
    },
    checkCoupon() {
      if (this.couponCodeChecked) return
      if (!this.couponCode) {
        this.couponErrorMsg = ''
        this.couponSuccessMsg = ''
        this.discount = 0
        this.couponCodeChecked = true
        return
      }
      this.couponErrorMsg = '驗證中'
      api
        .checkCoupon(this.couponCode, this.id, this.sum)
        .then(res => {
          if (res.code == 1000) {
            this.couponSuccessMsg = `成功折抵${res.data.couponAmount}元`
            this.couponErrorMsg = ''
            this.discount = res.data.couponAmount * -1
            this.couponCodeChecked = true
          }
        })
        .catch(err => {
          this.couponSuccessMsg = ''
          this.discount = 0
          this.couponErrorMsg = err.message || '未知錯誤'
          this.couponCodeChecked = true
        })
    },
    saveInfo() {
      const expired = new Date().getTime() + 1000 * 60 * 20 // 20分鍾
      const paymentDto = {
        BuyerInfo: this.buyerInfo,
        ShippingInfo: {},
        _shippingInfo: {},
        EinvoiceInfo: this.getEinvoiceInfo(),
        _receiptInfo: this.receipt,
        sameWithBuyer: this.sameWithBuyer,
        sameWithDelivery: this.sameWithDelivery,
        saveReceipt: this.saveReceipt,
      }
      if (this.recipientMethod === '2') {
        paymentDto.ShippingInfo = this.getShippingInfo()
        paymentDto._shippingInfo = this.recipient
      }
      localStorage.setItem(
        'shoppingCart',
        JSON.stringify({
          id: this.id,
          qty: this.qty,
          variation: this.variation,
          expired: expired,
          paymentInfo: paymentDto,
          storeGuid: this.storeGuid,
          deliveryType: this.recipientMethod,
          productInfo: this.productInfo,
        })
      )
      return paymentDto
    },
    piPay() {
      api
        .makeOrder(
          this.id,
          this.qty,
          this.storeGuid,
          5, // pi
          this.sum,
          0,
          this.couponCode,
          '',
          '',
          '',
          '',
          0,
          this.buyerInfo,
          this.recipientMethod === '2'
            ? [
                {
                  ProductVariationId: this.variation,
                  Quantity: this.qty,
                },
              ]
            : [],
          this.recipientMethod === '2' ? this.getShippingInfo() : {},
          this.getEinvoiceInfo(),
          this.saveReceipt
        )
        .then(res => {
          let err = false
          if (res.code == 1000) {
            this.expired = res.data.expired_At
            this.hppUrl = res.data.url
            // this.hppUrl = res.data.universal_Link
            this.updateInitialData()
          } else {
            err = true
            this.makeOrderStatus = 'error'
          }
          this.submitting = false
          this.goResultPage(err, res)
        })
        .catch(err => {
          this.makeOrderStatus = 'error'
          this.goResultPage(err)
          this.submitting = false
          console.log(err)
        })
    },
    ga() {
      gtag('event', 'purchase', {
        result: this.makeOrderStatus == 'error' ? '訂單失敗' : '訂單成立',
        value: this.sum,
        shipping: 0,
        payment_type: 'Pi拍錢包',
        currency: 'TWD',
        isGroupCoupon: this.productInfo.isGroupCoupon ? '成套票券' : '',
        coupon: this.couponCode,
        category: this.productInfo.deliveryType == 1 ? '票券' : '宅配',
        variant:
          this.productInfo.deliveryType == 1
            ? this.storeGuid
            : this.productInfo.spec,
        items: [
          {
            item_id: this.id,
            item_name: this.productInfo.title,
            // brand: 'Google',
            item_category: this.productInfo.deliveryType == 1 ? '票券' : '宅配',
            quantity: this.productInfo.isGroupCoupon ? 1 : this.qty,
            item_variant:
              this.productInfo.deliveryType == 1
                ? this.storeGuid
                : this.productInfo.spec,
            price: this.productInfo.price,
          },
        ],
      })
    },
    goResultPage(err, res) {
      this.ga()
      this.saveInfo()
      if (err || this.id == '9df9bffa-1eee-454b-8582-727332a1b307') {
        this.$router.replace({
          name: 'paymentResult',
          params: { status: 'error', err: err },
          query: { amount: this.sum, isPimode: true },
        })
      } else {
        this.$router.replace({
          name: 'paymentResult',
          params: {
            status: 'wait',
            expired: res.data.expired_At,
            deeplink: res.data.url,
          },
          query: {
            amount: this.sum,
            isPimode: true,
          },
        })
        location.href = res.data.url
        return
      }
    },
    updateInitialData() {
      const initialConfig = JSON.parse(localStorage.getItem('initial_config'))
      initialConfig.buyer = this.buyerInfo
      initialConfig.einvoice = this.getEinvoiceInfo()
      localStorage.setItem('initial_config', JSON.stringify(initialConfig))
    },
    getQtyOpts() {
      if (!this.productInfo.isGroupCoupon) {
        this.qtyOpts = [...Array(this.qtyMaxinum + 1).keys()].slice(1)
        console.log(this.qtyOpts)
      }
    },
    getStoreOpts() {
      if (this.storeOpts.length > 1) {
        this.storeOpts = this.storeOpts.filter(store => {
          return store.disabled == false
        })
        this.storeGuid = this.storeOpts[0].value
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .v-list-item--link::before {
  display: none;
}

::v-deep .v-list-item--active::before {
  display: block;
}

::v-deep .v-btn__content {
  font-size: 15px;
  font-weight: 600;
}
::v-deep .v-input.agreement-cus {
  padding-top: 0 !important;
}
::v-deep .v-messages {
  display: block !important;
  .v-messages__message {
    line-height: normal;
  }
}
::v-deep .check-col .v-messages {
  display: none !important;
}
::v-deep .v-input--selection-controls__input {
  height: auto;
}
::v-deep .v-input__append-inner {
  margin-top: 0 !important;
}
::v-deep .v-select,
::v-deep .v-text-field {
  .v-input__slot {
    padding: 12px 16px !important;
    border-radius: 12px;
    background-color: #f3f5f8 !important;
    &::before,
    &::after {
      display: none;
    }
    input {
      max-height: 22px;
    }
  }
}
.input-title {
  font-size: 13px;
  color: #989898;
  padding-bottom: 4px;
}
.payment-layout {
  background-color: #f3f5f8;

  .payment-title {
    font-size: 14px;
    color: #1a1a1a;
    font-weight: bold;
    padding-bottom: 11px;
    span {
      font-size: 13px;
      font-weight: 400;
      color: #9b9b9b;
      margin-left: 8px;
    }
  }
  .payment-section {
    background-color: white;
    box-shadow: 0 1px 0 0 #ededed;
    padding: 0px 4.8%;

    &__head {
      margin-top: 8px;
      font-size: 13px;
      color: #9b9b9b;
    }
    &.receipt {
      .v-label {
        font-size: 14px !important;
        color: #545454;
      }
      .receipt-note {
        font-size: 14px;
        color: #9b9b9b;
        padding: 7px 0 16px;
      }
    }
  }

  .v-text-field {
    margin-top: 0;
    padding-top: 0;
  }

  .payment-info {
    .product {
      background-color: #fff;
      padding: 20px 4.8%;
      display: flex;
      align-items: center;
      .image {
        width: 28.6%;
        height: 0;
        padding-bottom: 28.6%;
        border-radius: 16px;
        overflow: hidden;
        flex-shrink: 0;
        background: url('../../assets/img/placholder_512.svg');
        background-size: contain;
        background-repeat: no-repeat;
        img {
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
      }
      .detail {
        margin-left: 10px;
        .name {
          font-size: 16px;
          font-weight: bold;
          color: #383838;
          margin-bottom: 13px;
        }
        .price {
          .points {
            display: inline-block;
            width: 16px;
            img {
              width: 100%;
            }
          }
          .real-price {
            font-size: 18px;
            font-weight: bold;
            color: #1da7fc;
          }
          .ori-price {
            margin-left: 5px;
            font-size: 14px;
            font-weight: light;
            color: #9b9b9b;
            text-decoration: line-through;
          }
        }
      }
    }
    .order {
      margin-top: 8px;
      background-color: #fff;
      padding: 20px 4.8% 15px;
      .info-col {
        display: flex;
        justify-content: space-between;
        margin-bottom: 7px;
        .name,
        .value {
          font-size: 12px;
          color: #545454;
        }
        .value {
          max-width: 70%;
          text-align: right;
        }
        &.discount {
          .value {
            color: #fe585c;
          }
        }
        &.sum {
          .value {
            font-size: 15px;
            color: #1da7fc;
          }
        }
      }
    }
    .pi-mobile {
      font-size: 16px;
      color: #9a9a9a;
      padding: 12px 15px;
      border-radius: 16px;
      background-color: #f3f5f8;
    }
    .check-col {
      font-size: 14px;
      color: #545454;
    }
    ::v-deep .agreement-check {
      margin: 0;
      .v-messages {
        display: none;
      }
    }
  }

  .shipping-container {
    padding: 0 40px;
  }

  .underline-link {
    color: #1da7fc;
    border-bottom: solid 1px #1da7fc;
  }
  .change-delivery-place {
    margin-top: 8px;
    font-size: 13px;
    color: #9b9b9b;
  }
  .loveCodeGroup {
    padding-left: 28px;
  }
  .otherLovecode {
    padding-left: 32px;
    .lovecode-link {
      font-size: 12px;
      color: #1da7fc;
      letter-spacing: normal;
    }
  }
}

.payment-layout .payment-info .block-btm {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  border-top: 8px solid #f3f5f8;
  margin-top: 0;
  padding: 10px 4.8%;
}
</style>
